import { NavLink } from "react-router-dom";
import { handeLeaveSideBar, handeOnHoverSideBar } from "../components/const";
const MenuAgent = () => {
    return (
        <ul className="metismenu " id="menu" onMouseOver={() => handeOnHoverSideBar()} onMouseLeave={() => handeLeaveSideBar()}>
            <li>
                <NavLink to='/'>
                    <div className="parent-icon"><i className='bx fs-4 bx-category'></i>
                    </div>
                    <div className="menu-title">Clients</div>
                </NavLink>
            </li>
            {/* <li>
                <NavLink to='/products/add' >
                    <div className="parent-icon">
                        <i className="bx fs-4 bx-category"></i>
                    </div>
                    <div className="menu-title">Clients</div>
                </NavLink>
            </li>
            <li>
                <NavLink to='/products/stock-actuel' >
                    <i className="bx fs-4 bx-right-arrow-alt">
                    </i>Factures impayés
                </NavLink>
            </li> */}
        </ul>
    );
}
export default MenuAgent;